import React from "react";
import { Header } from '../../Components/Layout/Header.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'
import { NavLink } from "react-router-dom";
import { GameDetails } from '../../Components/Game/GameDetails.jsx'

export class AllPromotions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showBonusText: false,
            showUtrkaText: false,
            showIzazoviText: false,
            utrke: null,
            izazovi: null,
            promocijeTurniri: null
        }

        casino.utils.createPageGoogleTagManagerEvent('Promocije', 'Sve promocije', 'casino', this.props.user);
    }

    componentDidMount() {
        casino.repos.casinoUtrkeCLRepo.get(null).then(data => {
            this.setState({ utrke: data });
            if (data.length > 0) this.setState({ showUtrkaText: true });
        });

        casino.repos.casinoAchievementsCLRepo.get(null).then(data => {
            if (data.success) {
                this.setState({ izazovi: data.achievements });
                if (data.achievements.filter(x => x.percentage.issued == 0 && !x.isNotAchieved).length > 0) this.setState({ showIzazoviText: true });
            }
        });

        casino.repos.casinoPromotionsRepo.get().then(components => {

            //custom komponente postavimo da su aktivne jer nemaju datum trajanja
            let customCodes = ['first-depozit', 'superklub', 'drops-and-wins', 'vip'];
            customCodes.forEach((code) => {
                var index = components.findIndex(x => x.code == code);
                components[index].finished = false;
            });

            this.setState({ promocijeTurniri: components });
        });

        if (this.props.bonuses.filter(it => it.isActive).length > 0) {
            this.setState({ showBonusText: true });
        }
    }

    getActiveBonuses() {

        let active = this.state.promocijeTurniri && this.state.promocijeTurniri.filter((bonus) => { return !bonus.finished }).sort((a, b) => a.order > b.order ? 1 : -1).length;

        if (active == 1) {
            return "1 aktivan bonus";
        } else if (active >= 2 && active <= 4) {
            return `${active} aktivna bonusa`;
        } else {
            return `${active} aktivnih bonusa`;
        }
    }

    getActiveUtrke() {
        let active = this.state.utrke.filter(it => it.aktivna).length;
        let total = this.state.utrke.length;

        if (active == 1) {
            return "1 aktivna utrka";
        } else if (active >= 2 && active <= 4) {
            return `${active} aktivne utrke`;
        } else if (active >= 5) {
            return `${active} aktivnih utrka`;
        } else {
            if (total == 1 || total >= 5) {
                return '1 utrka u pripremi';
            } else if (total >= 2 && total <= 4) {
                return `${total} utrke u pripremi`;
            }
        }
    }

    getActiveIzazovi() {
        let active = this.state.izazovi.filter(x => x.percentage.issued == 0 && !x.isNotAchieved).length;
        if (active == 1) {
            return "1 neodigran izazov";
        } else if (active >= 2 && active <= 4) {
            return `${active} neodigrana izazova`;
        } else {
            return `${active} neodigranih izazova`;
        }
    }

    render() {
        return (
            <div>
                <MetaTags title="Sve promocije - SuperSport CASINO" description="Sve promocije u SuperSport CASINU!" />
                <Header key="header" {...this.state} {...this.props}></Header>
                <div className='white-background'>
                    <div className="all-promo-container">
                        <div className="promotions">
                            <NavLink to={'/promotions' + (casino.config.fromNativeApp ? "?fromnative=1" : "")}>
                                <div className="title-2">Bonusi</div>
                                <img src="Content/Images/AllPromotions/bonus-background.png" />
                                <img className="sub-image-1" src="Content/Images/AllPromotions/bonus-lady.png" />
                                <img className="sub-image-2" src="Content/Images/AllPromotions/bonus-man.png" />
                                {this.state.showBonusText && <div className="active-items">{this.getActiveBonuses()}</div>}
                            </NavLink>
                        </div>
                        <div className="utrke">
                            <NavLink to={"/casino-utrke" + (casino.config.fromNativeApp ? "?fromnative=1" : "")}>
                                <div className="title-2">Utrke</div>
                                <img src="Content/Images/AllPromotions/utrke-background.png"></img>
                                <img className="sub-image-1" src="Content/Images/AllPromotions/man-hero.png" />
                                <img className="sub-image-2" src="Content/Images/AllPromotions/woman-hero.png" />
                                {this.state.showUtrkaText && <div className="active-items">{this.getActiveUtrke()}</div>}
                            </NavLink>
                        </div>
                        <div className="izazovi">
                            <NavLink to={"/casino-izazovi" + (casino.config.fromNativeApp ? "?fromnative=1" : "")}>
                                <div className="title-2">Izazovi</div>
                                <img src="Content/Images/AllPromotions/izazovi-background.png"></img>
                                <img className="sub-image-1" src="Content/Images/AllPromotions/robot.png" />
                                <img className="sub-image-2" src="Content/Images/AllPromotions/char-1.png" />
                                <img className="sub-image-3" src="Content/Images/AllPromotions/char-2.png" />
                                <img className="sub-image-4" src="Content/Images/AllPromotions/star.png" />
                                {this.state.showIzazoviText && <div className="active-items">{this.getActiveIzazovi()}</div>}
                            </NavLink>
                        </div>
                    </div>
                </div>
                <GameDetails {...this.props} {...this.state} routePrefix="/all-promotions" loadGames={true}></GameDetails>
                <ObavijestiCasino {...this.props}></ObavijestiCasino>
            </div>);
    }
}